<template>
    <div>

        <el-row>
            <div style="width: 30%; height: 40px; background-color: #e5f0ec; border-radius:25px;">
                <el-row>
                    <el-col :span="12" :offset="2"><span style="line-height: 40px; ">上下移动调整部门顺序</span></el-col>
                    <el-col :span="10" style="line-height: 40px;">
                        <el-button
                            style="background-color: #006E4B; color: #FFFFFF; border: 1px #006E4B solid; font-size: 15px;padding: 5px 15px;"
                            size="mini" @click="save">保存</el-button>
                        <el-button
                            style="background-color: #FFFFFF; color: #006E4B; border: 1px #006E4B solid; font-size: 15px;padding: 5px 15px;"
                            size="mini" @click="Return">取消</el-button>
                    </el-col>
                </el-row>
            </div>
        </el-row>

        <el-row style="margin-top: 10px;">
            <div class="sort">
                <el-table :header-cell-style="{background:'#F0F0F0',color:'#000000'}" ref="multipleTable"
                    :data="tableData" tooltip-effect="dark" style="width: 100%;" height="520" row-key="id">
                    <el-table-column width="100" align="center">
                        <template slot-scope="scope_1">
                            <img src="../../../assets/icon/排序icon@2x.png" />
                        </template>
                    </el-table-column>
                    <el-table-column align="center" label="序号" width="50">
                        <template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
                    </el-table-column>
                    <el-table-column prop="project_name" align="center" label="部门名称">
                        <template slot-scope="scope">
                            {{condition.flag == 'plate' ? scope.row.project_name : scope.row.organize_name}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="organize_number" align="center" label="部门人数"></el-table-column>
                </el-table>
            </div>
        </el-row>
    </div>
    </el-row>

    </div>
</template>

<script>
    import Sortable from 'sortablejs'

    export default {
        data() {
            return {
                //列表相关
                tableData: [],

                //条件
                condition: {
                    //部门id
                    project_id: "",
                    //标识
                    flag: "group"
                },
            }
        },
        mounted() {
            // 阻止默认行为
            document.body.ondrop = function(event) {
                event.preventDefault();
                event.stopPropagation();
            };
            this.rowDrop();
        },
        methods: {
            //查询
            async Find() {
                var url = "organize/select",
                    record = {
                        organize_id: this.condition.project_id,
                        spare8: this.condition.flag,
                    };

                var data = await this.$globals.AxiosPost(url, record);
                if (data == '-2000') {
                    this.$message.error('服务器未响应！请稍后重试');
                } else {
                    var code = data.code;
                    var data = data.data;
                    if (code == '200') {
                        this.tableData = data;
                    } else {
                        this.$message.warning('请求失败！请稍后重试');
                    }
                }
            },
            //保存
            async save() {
                //获取排序
                this.tableData.forEach((item, index) => {
                    item.sort = index + 1;
                })

                var url = "organize/batchUpdateSort";

                var data = await this.$globals.AxiosPost(url, this.tableData);
                if (data == '-2000') {
                    this.$message.error('服务器未响应！请稍后重试');
                } else {
                    var code = data.code;
                    var data = data.data;
                    if (code == '200') {
                        this.$message.success(data);
                        this.Return();
                    } else {
                        this.$message.warning(data);
                    }
                }
            },
            //返回
            Return() {
                this.Find();
                this.$emit("Return");
            },
            //行拖拽
            rowDrop() {
                var tbody = document.querySelector('.sort .el-table__body-wrapper tbody')
                var that = this
                Sortable.create(tbody, {
                    onEnd({
                        newIndex,
                        oldIndex
                    }) {
                        var currRow = that.tableData.splice(oldIndex, 1)[0]
                        that.tableData.splice(newIndex, 0, currRow)
                    }
                })
            },
        }
    }
</script>

<style scoped="scoped">
</style>



// WEBPACK FOOTER //
// Jtzzjggl_department_sort.vue?1c6283ca